var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThetaEdgecloudWordmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 271.651,
    height: 47.938,
    viewBox: "0 0 271.651 47.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.056,
    y1: 0.102,
    x2: 0.904,
    y2: 0.924,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb3dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#e139cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#9b1bdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#6e09eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e02f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(-298 -1199.798)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 271.651,
    height: 47.938,
    transform: "translate(298 1199.798)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M315.832,1220.455v-4.279a1.592,1.592,0,0,1,1.944-1.553,13.246,13.246,0,0,1,10.137,11.05,1.6,1.6,0,0,1-1.573,1.829h-4.18a1.589,1.589,0,0,1-1.552-1.258,5.935,5.935,0,0,0-3.766-4.3A1.572,1.572,0,0,1,315.832,1220.455Zm-3.9-5.841a13.252,13.252,0,0,0-9.981,9.967,1.6,1.6,0,0,0,1.549,1.958h4.282a1.618,1.618,0,0,0,1.506-1.084,5.942,5.942,0,0,1,3.514-3.505,1.614,1.614,0,0,0,1.086-1.5v-4.283A1.6,1.6,0,0,0,311.927,1214.614Zm.873,18.441a5.94,5.94,0,0,1-3.509-3.488,1.62,1.62,0,0,0-1.5-1.079H303.5a1.6,1.6,0,0,0-1.548,1.96,13.252,13.252,0,0,0,9.975,9.941,1.6,1.6,0,0,0,1.956-1.549v-4.287A1.607,1.607,0,0,0,312.8,1233.055Zm7.987-20.538a16.144,16.144,0,0,1,3.492,1.926,1.6,1.6,0,0,0,1.9.009,10.53,10.53,0,0,1,16.544,6.266,1.588,1.588,0,0,0,1.553,1.264h4.186a1.59,1.59,0,0,0,1.575-1.826,17.831,17.831,0,0,0-29.779-10.26A1.586,1.586,0,0,0,320.787,1212.517Zm27.656,11.415h-4.191a1.589,1.589,0,0,0-1.55,1.25,10.526,10.526,0,0,1-10.26,8.232H317.421a1.589,1.589,0,0,0-1.589,1.59v4.118a1.589,1.589,0,0,0,1.589,1.589h15.021a17.834,17.834,0,0,0,17.575-14.944A1.59,1.59,0,0,0,348.443,1223.932Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M443.929,1230.876v-5.2h4.12v-2.627h-7.107V1233.5h7.983v-2.627Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 7.906,
    height: 2.627,
    transform: "translate(440.942 1215.477)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M463.594,1219.289v10.4c0,2.729-1.8,3.811-4.532,3.811h-4.609v-18.026h4.609C461.792,1215.477,463.594,1216.559,463.594,1219.289Zm-4.635-1.185H457.44v12.772h1.519c.979,0,1.648-.36,1.648-1.648v-9.476C460.607,1218.465,459.938,1218.1,458.959,1218.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M478.513,1229.9c0,2.781-1.8,3.811-4.532,3.811h-.206c-2.73,0-4.532-1-4.532-3.811v-10.816c0-2.678,1.8-3.811,4.532-3.811h.206c2.729,0,4.532,1.133,4.532,3.811v2.576h-2.987v-2.112c0-1.288-.67-1.648-1.648-1.648s-1.648.36-1.648,1.648v9.888c0,1.288.669,1.648,1.648,1.648s1.648-.36,1.648-1.648v-2.678h-1.751v-2.523h4.738Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M484.185,1233.5v-18.026h7.9v2.627h-4.918v4.944h4.12v2.627h-4.12v5.2h4.995v2.627Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M506.749,1229.9c0,2.781-1.8,3.811-4.532,3.811h-.051c-2.73,0-4.533-1-4.533-3.811v-10.816c0-2.678,1.8-3.811,4.533-3.811h.051c2.73,0,4.532,1.133,4.532,3.811v3.3h-2.987v-2.833c0-1.262-.618-1.648-1.57-1.648s-1.571.386-1.571,1.648v9.888c0,1.262.618,1.648,1.571,1.648s1.57-.386,1.57-1.648v-3.27h2.987Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M519.994,1233.5h-7.6v-18.026h2.987v15.348h4.609Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M529.753,1215.271h.206c2.729,0,4.532,1.082,4.532,3.811V1229.9c0,2.73-1.8,3.811-4.532,3.811h-.206c-2.73,0-4.533-1.081-4.533-3.811v-10.816C525.22,1216.327,527.023,1215.271,529.753,1215.271Zm.1,15.811c.978,0,1.648-.36,1.648-1.648v-9.888c0-1.288-.67-1.648-1.648-1.648s-1.648.36-1.648,1.648v9.888C528.208,1230.722,528.877,1231.082,529.856,1231.082Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M549.242,1229.9c0,2.781-1.751,3.811-4.48,3.811h-.1c-2.73,0-4.481-1-4.481-3.811v-14.421h2.987v13.957c0,1.288.567,1.648,1.545,1.648s1.545-.36,1.545-1.648v-13.957h2.987Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M564.148,1219.289v10.4c0,2.729-1.8,3.811-4.532,3.811h-4.609v-18.026h4.609C562.346,1215.477,564.148,1216.559,564.148,1219.289Zm-4.635-1.185h-1.519v12.772h1.519c.979,0,1.648-.36,1.648-1.648v-9.476C561.161,1218.465,560.492,1218.1,559.513,1218.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M381.508,1215.178v7.52h3.425v-7.52h2.988V1233.2h-2.988v-7.828h-3.425v7.828h-2.987v-18.026Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M393.713,1233.2v-18.026h7.906v2.627H396.7v4.944h4.12v2.627H396.7v5.2h5v2.626Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M415.714,1217.805H412.7v15.4h-2.987v-15.4H406.7v-2.627h9.013Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M425.8,1229.187h-3.3l-.644,4.017h-2.884l3.348-18.026h3.76l3.4,18.026h-3.039Zm-.386-2.472-1.262-8.009-1.261,8.009Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 8.985,
    height: 2.619,
    transform: "translate(364.256 1215.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M364.256,1222.655h3.013V1233.2h2.978v-10.549h2.994v-2.619h-8.985Z",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThetaEdgecloudWordmark);
export default __webpack_public_path__ + "static/media/theta-edgecloud-wordmark.64465811cdf6fffd8d7812dd61652925.svg";
export { ForwardRef as ReactComponent };